import { API_BASE_URL } from "src/config/apiBase";
import { decryptToken } from "../utils/getToken";
import NotificationCenter from "../../shared/notifications/NotificationCenter";

const NotificationsPage = () => (
    <NotificationCenter
        apiUrl={API_BASE_URL}
        getToken={() => decryptToken("accessToken") || ""}
        role="staff"
    />
);

export default NotificationsPage;
